import React from 'react';
import './WaterAllocationOrderNOC.css'; // Create a CSS file for Water Allocation Order NOC specific styles if needed
import Header4 from '../../components/header/header4/Header4';
import ServicesHeroSection from '../../components/services_hero_section/ServicesHeroSection';
import Footer from '../../components/footer/Footer';
import ServicesOverviewSection from '../../components/services_overview_section/ServicesOverviewSection';
import img_water_allocation_banner from '../../assets/images/water-1.jpg'; // Replace with the actual image for Water Allocation Order NOC
import { FaWater, FaCertificate, FaRegCheckCircle, FaGavel, FaClipboardList } from 'react-icons/fa';
import ServicesBenefitsSection from '../../components/services_benefits_section/ServicesBenefitsSection';
import ServicesOurProcessSection from '../../components/services_our_process_section/ServicesOurProcessSection';
import ActsAndRulesSection from '../../components/acts_rules_section/ActsAndRulesSection';
import DocumentChecklist from '../../components/check_list_section/CheckListSection';

export default function WaterAllocationOrderNOC() {
  const waterAllocationBenefits = [
    {
      icon: <FaWater />,
      title: 'Sustainable Water Use',
      text: 'Ensure responsible and sustainable use of water resources with proper allocation orders.',
    },
    {
      icon: <FaCertificate />,
      title: 'Legal Compliance',
      text: 'Comply with regulations to avoid penalties or legal issues associated with water use.',
    },
    {
      icon: <FaRegCheckCircle />,
      title: 'Operational Continuity',
      text: 'Ensure uninterrupted water supply for your operations or construction with proper allocation.',
    },
    {
      icon: <FaGavel />,
      title: 'Avoid Penalties',
      text: 'By obtaining the water allocation order, you avoid fines and legal repercussions for non-compliance.',
    },
  ];

  const steps = [
    {
      icon: <FaClipboardList />,
      title: 'Initial Consultation',
      description: 'Discuss your water usage requirements and understand the need for allocation.',
    },
    {
      icon: <FaWater />,
      title: 'Water Assessment',
      description: 'Evaluate the water consumption needs and assess available resources for allocation.',
    },
    {
      icon: <FaCertificate />,
      title: 'Document Preparation',
      description: 'Prepare the required documents and water usage plans for the application submission.',
    },
    {
      icon: <FaRegCheckCircle />,
      title: 'Application Submission',
      description: 'Submit the water allocation order application to the relevant authorities.',
    },
    {
      icon: <FaGavel />,
      title: 'Order Issuance',
      description: 'Receive the water allocation order NOC after compliance verification.',
    },
  ];

  const acts = [
    'Water Resources Regulation Act',
    'National Water Policy',
    'State Water Allocation Rules',
  ];

  const explanation =
    'The Water Allocation Order NOC is issued to ensure that water usage is managed sustainably and that industries or projects are complying with the legal frameworks governing water use. Obtaining this NOC is essential for legal operations and avoiding penalties for unauthorized water consumption.';

  const checklistItems = [
    { name: 'Water Consumption Plan', description: 'Submit a detailed water consumption plan for your operations.' },
    { name: 'Water Resource Availability', description: 'Provide an assessment of water resources available for allocation.' },
    { name: 'Environmental Impact Assessment', description: 'Attach an environmental impact assessment regarding water use.' },
    { name: 'No Objection Certificate (NOC)', description: 'Include a copy of the NOC from local authorities or other required agencies.' },
  ];

  return (
    <>
      <Header4 />
      <ServicesHeroSection
        headline="Water Allocation Order NOC"
        subheading="Ensure sustainable water use and comply with legal requirements through expert water allocation order NOC assistance."
        ctaPrimary={{ text: 'Request Consultation', link: '/contact-us' }}
        ctaSecondary={{ text: 'Learn More', link: '/water-allocatio-norder-noc' }}
        backgroundImage={img_water_allocation_banner} // Pass the background image here
      />

      <ServicesOverviewSection
        title="What is Water Allocation Order NOC?"
        description="The Water Allocation Order NOC is a crucial document that ensures the legal allocation of water resources to industries or projects. It is required to ensure the sustainable use of water and legal compliance."
        image={img_water_allocation_banner} // Image for Water Allocation Order NOC process
        altText="Water Allocation Order NOC Process"
      />

      <ServicesBenefitsSection
        title="Why You Need Water Allocation Order NOC"
        description="Learn the importance of obtaining the Water Allocation Order NOC to ensure legal compliance and sustainable water use."
        benefits={waterAllocationBenefits}
      />

      <ActsAndRulesSection
        title="Acts and Rules Covered"
        subtitle="Water Resource Regulations and Compliance"
        acts={acts}
        explanation={explanation}
      />

      <ServicesOurProcessSection
        title="Our Simple Water Allocation Order Process"
        steps={steps}
      />

      <DocumentChecklist
        mainTitle="Complete Your Onboarding"
        checklistTitle="Water Allocation Order NOC Onboarding Document Checklist"
        items={checklistItems}
      />

      <Footer />
    </>
  );
}
